module.exports = __webpack_public_path__ + "img/news-02.99e16f7f.png";